import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'syr-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.scss']
})
export class TipsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
